/**
 * This config should be required before:
 *  require("offset-cantina") or require("offset-analytics")
 */
window.OFFSET = window.OFFSET || {};
window.OFFSET['consent'] = {
    version: "2026-06-01",
    showReopenButton: false,
};
// window.OFFSET['debug'] = true;
window.OFFSET['apiKey'] = "QY8XfyBGwBEN6sAmr";
window.OFFSET['logoutUrl'] = "/logout/";
window.OFFSET['cartUrl'] = "/nextcart/?cantina=true";
window.OFFSET['checkoutUrl'] = "/nextcheckout/?cantina=true";
window.OFFSET['shopUrl'] = "/nextshop/?cantina=true";